__webpack_require__.p = "/TastyTreatsReact/";